import React, { createContext, useState } from "react";

export let BaseUrlContext = createContext(0);

export default function BaseUrlContextProvider(props) {
    const [baseUrl, setBaseUrl] = useState(`https://saudigermanacademy.com/Aadm25/api`);
    const [imgUrl, setImgUrl] = useState(`https://saudigermanacademy.com/Aadm25/uploads/`);
    return <>
        <BaseUrlContext.Provider value={{ baseUrl, setBaseUrl, imgUrl, setImgUrl }}>
            {props.children}
        </BaseUrlContext.Provider>
    </>
}
